import axiosInstance from "../config/axiosInstance";
import { ApiRoutes } from "../constants/ApiRoutes";
import { QueryKeys } from "../constants/QueryKeys";
import { MutateKeys } from "../constants/MutateKeys";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { UpdateRuleEngineContentType } from "../Types/ruleEngineTypes";
import { generatePath } from "react-router-dom";

const RuleEngineServices = () => {
  const queryClient = useQueryClient();

  const { FETCH_RULE_ENGINE_CONTENTS, UPDATE_RULE_ENGINE_CONTENTS } = ApiRoutes;
  const { FETCH_RULE_ENGINE_CONTENT_KEY } = QueryKeys;
  const { UPDATE_RULE_ENGINE_KEY } = MutateKeys;
  const FetchRuleEngineContents = () => {
    const fetchRuleEngineContents = async () => {
      const { data } = await axiosInstance.get(FETCH_RULE_ENGINE_CONTENTS);
      return data;
    };
    return useQuery({
      queryKey: [FETCH_RULE_ENGINE_CONTENT_KEY],
      queryFn: fetchRuleEngineContents,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    });
  };

  const UpdateRuleEngineContents = () => {
    const updateRuleEngineContents = async (
      params?: UpdateRuleEngineContentType,
    ) => {
      const { id, ...cleanedParams } = params;
      const payload = {
        entityData: {
          ...cleanedParams,
        },
      };
      const url = generatePath(UPDATE_RULE_ENGINE_CONTENTS, {
        id: id,
      });
      const { data } = await axiosInstance.put(url, payload);
      return data;
    };
    return useMutation({
      mutationKey: [UPDATE_RULE_ENGINE_KEY],
      mutationFn: updateRuleEngineContents,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [FETCH_RULE_ENGINE_CONTENT_KEY],
        });
      },
    });
  };
  return {
    FetchRuleEngineContents,
    UpdateRuleEngineContents,
  };
};

export default RuleEngineServices;
